export default "__VITE_ASSET__B9L1G$TB__"